export class MonetagController {
  private static _instance: MonetagController
  private _sdkLoaded: boolean = false

  private constructor() {}

  public static get Instance(): MonetagController {
    if (!MonetagController._instance) {
      MonetagController._instance = new MonetagController()
    }
    return MonetagController._instance
  }

  public loadSdk(): Promise<boolean> {
    if (this._sdkLoaded) {
      return Promise.resolve(true)
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = '//cwwsh.com/sdk.js'
      script.setAttribute('data-zone', '9221655')
      script.setAttribute('data-sdk', 'show_9221655')
      script.async = true

      script.onload = () => {
        this._sdkLoaded = true
        resolve(true)
      }

      script.onerror = () => reject(new Error('Unable to load SDK from cwwsh.com'))

      document.head.appendChild(script)
    })
  }

  public showRewardedInterstitial(): Promise<void> {
    if (!(window as any).show_9221655) {
      return Promise.reject(new Error('SDK function show_9388765 not available'))
    }

    return (window as any).show_9388765().then(() => {
      // Дія після перегляду реклами
      alert('You have seen an ad!')
      // Тут можна викликати будь-який метод для нагороди користувача
    })
  }
}
